import { render, staticRenderFns } from "./NoCameraPermission.vue?vue&type=template&id=1541982c&scoped=true&"
import script from "./NoCameraPermission.vue?vue&type=script&lang=ts&"
export * from "./NoCameraPermission.vue?vue&type=script&lang=ts&"
import style0 from "./NoCameraPermission.vue?vue&type=style&index=0&id=1541982c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541982c",
  null
  
)

export default component.exports